import { useUnit } from 'state/unit';
import useSanitizedAudioSrc from './useSanitizedAudioSrc';

export default function useSanitizedUnitAudio() {
  const unit = useUnit();
  return useSanitizedAudioSrc(unit?.episode?.entireAudioUrl);
}
